import './GestureFuncParams.css'
import React from 'react';

function GestureComponentParams({ id, component, prefix }) {

    const renderParams = () => {
        return component?.keys?.map((key, index) => (
            <div key={`key-${id}-component-key-${index}`} className='params-section'>
                <select
                    name='type'
                    value={"key"}
                    disabled={true}
                >
                    <option value='key'>Chave</option>
                </select>
                <input
                    type='text'
                    name='value'
                    value={`${prefix}.${key.name}`}
                    disabled={true}
                />
            </div>
        ));
    };

    return (
        <div className='function-section'>
            {component && (
                <>
                    {renderParams()}
                </>
            )}
        </div>
    );
}

export default GestureComponentParams
